module.exports = __webpack_public_path__ + "img/路径 8.90023f6b.svg";